export type TValueChainActiveAgentKind =
  | 'n-tier'
  | 'reputation-monitoring'
  | 'regulation-monitoring'
  | 'finance-monitoring'
  | 'ownership-monitoring'
  | 'climate-monitoring'
  | null;

export const isMonitoringAgentKind = (
  activeAgentKind: TValueChainActiveAgentKind,
): activeAgentKind is
  | 'reputation-monitoring'
  | 'regulation-monitoring'
  | 'finance-monitoring'
  | 'ownership-monitoring'
  | 'climate-monitoring' => (
  activeAgentKind === 'reputation-monitoring'
  || activeAgentKind === 'regulation-monitoring'
  || activeAgentKind === 'finance-monitoring'
  || activeAgentKind === 'ownership-monitoring'
  || activeAgentKind === 'climate-monitoring'
);
